// extracted by mini-css-extract-plugin
module.exports = {"deviceItem":"TrustedDevices_deviceItem__2_PvH"};